import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import { LootBoxService } from "../../services/lootBox/LootBoxService";
import Spinner from "../Spinner";

interface Props {
  lootBoxService: LootBoxService;
  hideLootBox: () => void;
  visibleTime?: number;
}

export const LootBox: React.FC<Props> = ({
  lootBoxService,
  hideLootBox,
  visibleTime = 15000,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [buttonPressed, setButtonPressed] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const timeoutId = useRef<NodeJS.Timeout>();
  const classes = ["dqm-tcui-loot-box__spin-button"];

  useEffect(() => {
    lootBoxService.start();
  }, [lootBoxService]);

  useEffect(() => {
    timeoutId.current = setTimeout(() => {
      lootBoxService.cancel();
      hideLootBox();
    }, visibleTime);
  }, [visibleTime, hideLootBox, lootBoxService]);

  const onTouchStart = () => {
    if (!isLoading && !buttonPressed) {
      setButtonPressed(true);
      setTimeout(() => {
        setButtonPressed(false);
        setIsLoading(true);
      }, 500);
      handleLootBoxClick();
    }
  };

  const handleLootBoxClick = async () => {
    clearTimeout(timeoutId.current!);

    await lootBoxService.draw();

    setIsLoading(false);
    setIsFinished(true);
    setTimeout(() => {
      hideLootBox();
    }, 2000);
  };

  const handleBackClick = () => {
    clearTimeout(timeoutId.current!);
    lootBoxService.cancel();
    hideLootBox();
  };

  if (buttonPressed) {
    classes.push("dqm-tcui-action-button-container__button_pressed");
  }

  return (
    <div className="dqm-tcui-info_container dqm-tcui-loot-box__container">
      {isFinished ? (
        <h1
          className="dqm-tcui-info_container__title"
          data-testid="loot-box-thank-you"
        >
          Kiitos!
        </h1>
      ) : (
        <>
          <h1 className="dqm-tcui-info_container__title">
            Pyöräytä onnenpyörää
          </h1>
          <div className="dqm-tcui-loot-box__content dqm-tcui-info_container__text">
            <button
              className={classes.join(" ")}
              onTouchStart={onTouchStart}
              data-testid="loot-box-spin-button"
            >
              <span className="dqm-tcui-loot-box__spin-button-title">
                {isLoading ? <Spinner /> : "Pyöräytä"}
              </span>
            </button>
          </div>
          {!isLoading && (
            <div
              className="dqm-tcui-loot-box__back-button dqm-tcui-info_container__text"
              onClick={handleBackClick}
              data-testid="loot-box-back-button"
            >
              <FontAwesomeIcon icon={faArrowLeftLong} />
            </div>
          )}
        </>
      )}
    </div>
  );
};
